import type { FunctionComponent } from 'react';

import type { SourceType } from '@trello/analytics-types';
import type { PopoverProps, UsePopoverResult } from '@trello/nachos/popover';
import type { TestId } from '@trello/test-ids';

import { CreateBoardPopoverScreenId } from './CreateBoardPopoverScreens';
import { LazyCreateBoardPopoverWithAd } from './LazyCreateBoardPopoverWithAd';

export const screenAnalyticsNames: {
  [key: number]:
    | 'createBoardInlineDialog'
    | 'createFromTemplateInlineDialog'
    | 'useTemplateInlineDialog';
} = {
  [CreateBoardPopoverScreenId.CreateBoard]: 'createBoardInlineDialog',
  [CreateBoardPopoverScreenId.CreateBoardFromTemplate]:
    'useTemplateInlineDialog',
  [CreateBoardPopoverScreenId.SelectTemplate]: 'createFromTemplateInlineDialog',
};
export interface CreateBoardPopoverProps {
  show: UsePopoverResult<HTMLElement>['show'];
  hide: UsePopoverResult<HTMLElement>['hide'];
  push: UsePopoverResult<HTMLElement>['push'];
  pop: UsePopoverResult<HTMLElement>['pop'];
  analyticsSource: SourceType;
  popoverProps: PopoverProps<HTMLElement>;
  preSelectedWorkspaceId?: string;
  testId?: TestId;
}

export const CreateBoardPopover: FunctionComponent<CreateBoardPopoverProps> = (
  props,
) => {
  return <LazyCreateBoardPopoverWithAd {...props} />;
};
